<h2 mat-dialog-title class="mb-0">Stay in the loop</h2>

<div mat-dialog-content class="marketing-consent-content">
    <p>We’d love to keep you up to date with product updates, helpful tips, company news, and occasional offers from Fire Survey Pro by email.</p>
    <p class="mb-0">You can change this preference at any time from your user settings.</p>
</div>

<div mat-dialog-actions align="end" class="marketing-consent-actions">
    <button mat-stroked-button color="primary" [disabled]="loading" (click)="updateMarketingConsent(false)">No thanks</button>
    <button mat-flat-button color="primary" [disabled]="loading" (click)="updateMarketingConsent(true)">Yes, keep me updated</button>
</div>

